import { hasIn } from 'ramda';
import {
  COLORADO_TENANT_ID,
  OREGON_TENANT_ID,
  VIRGINIA_TENANT_ID,
  DARTMOUTH_TENANT_ID,
  RUTGERS_TENANT_ID,
  DEMO_TENANT_ID,
  TRIAL_TENANT_ID,
  CS_TENANT_ID,
} from 'utils/constants';

const domain = window.location.hostname;
const domainPort = window.location.port;

const localColoradoPort = 3000;
const localOregonPort = 3001;
const localVirginiaPort = 3002;
const localDartmouthPort = 3003;
const localRutgersPort = 3004;
const localDemoPort = 3005;
const localTrialPort = 3006;

const localCsPort = 3010;

export const currentEnvironment = `${process.env.REACT_APP_NODE_ENV}`;

/*
export const reactapp_APIURI = `${process.env.REACT_APP_API}`;

export const reactapp_COLORADOAPIURI = `${process.env.REACT_APP_API_COLORADO_URL}`;
export const reactapp_OREGONAPIURI = `${process.env.REACT_APP_API_OREGON_URL}`;
export const reactapp_VIRGINIAAPIURI = `${process.env.REACT_APP_API_VIRGINIA_URL}`;
export const reactapp_DARTMOUTHAPIURI = `${process.env.REACT_APP_API_DARTMOUTH_URL}`;
export const reactapp_DEMOAPIURI = `${process.env.REACT_APP_API_DEMO_URL}`;
export const reactapp_TRIALAPIURI = `${process.env.REACT_APP_API_TRIAL_URL}`;
export const reactapp_RUTGERSAPIURI = `${process.env.REACT_APP_API_RUTGERS_URL}`;
*/

export const reactapp_APIURL = getAPITenantIdForDomain();
export const graphQL_APIURI = reactapp_APIURL+'/graphql';

export const cryptoKeyText = `${process.env.REACT_APP_AES_ENCRYPTION_KEY}`;

export const COLORADO_CLARITY_ID = `${process.env.REACT_APP_COLORADO_CLARITY_ID}`;
export const OREGON_CLARITY_ID = `${process.env.REACT_APP_OREGON_CLARITY_ID}`;
export const VIRGINIA_CLARITY_ID = `${process.env.REACT_APP_VIRGINIA_CLARITY_ID}`;
export const DARTMOUTH_CLARITY_ID = `${process.env.REACT_APP_DARTMOUTH_CLARITY_ID}`;

export const RECAPTCHA_SITE_KEY = '6LfSfzAqAAAAAPpTXZyoLvBjQguECxMasJbCe_FF'; // process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

export function getTenantIdForDomain(): string {
  if (domain === 'localhost') {
    return getTenantIdForLocalhost();
  }

  if (currentEnvironment === 'staging' || currentEnvironment === 'development') {
    return getTenantForStaging();
  }

  if (currentEnvironment === 'production') {
    return getTenantForProduction();
  }

  return '';
}


function getTenantIdForLocalhost(): string {
  const port = Number(window.location.port);

  switch (port) {
    case localColoradoPort:
      return COLORADO_TENANT_ID;
    case localOregonPort:
      return OREGON_TENANT_ID;
    case localVirginiaPort:
      return VIRGINIA_TENANT_ID;
    case localRutgersPort:
        return RUTGERS_TENANT_ID;
    case localDemoPort:
      return DEMO_TENANT_ID;
    case localTrialPort:
      return TRIAL_TENANT_ID;
    case localCsPort:
      return CS_TENANT_ID;
    default:
      return '';
  }
}


export function getAPITenantIdForDomain(): string {
  if (currentEnvironment === 'development') {
    return getAPITenantForDevelopment();
  }

  if (currentEnvironment === 'staging' || currentEnvironment === '') {
    return getAPITenantForStaging();
  }

  if (currentEnvironment === 'production') {
    return getAPITenantForProduction();
  }

  return '';
}

function getAPITenantForDevelopment(): string {
  // console.log('`${domain.toLowerCase()}:${domainPort}`', `${domain.toLowerCase()}:${domainPort}`);
  if (`${domain.toLowerCase()}:${domainPort}` === 'localhost:3000') return 'http://localhost:4002';
  if (`${domain.toLowerCase()}:${domainPort}` === 'localhost:3001') return 'http://localhost:4003';
  if (`${domain.toLowerCase()}:${domainPort}` === 'localhost:3002') return 'http://localhost:4004';
  if (`${domain.toLowerCase()}:${domainPort}` === 'localhost:3003') return 'http://localhost:4005';
  if (`${domain.toLowerCase()}:${domainPort}` === 'localhost:3004') return 'http://localhost:4006';
  if (`${domain.toLowerCase()}:${domainPort}` === 'localhost:3005') return 'http://localhost:4007';
  if (`${domain.toLowerCase()}:${domainPort}` === 'localhost:3006') return 'http://localhost:4008';

  return 'https://localhost:4002';
}

function getAPITenantForStaging(): string {
  // OIT data center. Every tenant domain there is same-origin, so this is a SUFFIX match
  // while getTenantForStaging below stays exact: the API base is identical for all of our
  // domains, the tenant is not. That asymmetry is deliberate -- it means adding a tenant
  // is one edit (the tenant switch) rather than two, and the edit you could forget is the
  // one that fails loudly rather than the one that silently serves Demo's data.
  //
  // Returns an EMPTY string, which is not an oversight: every call site builds its URL as
  // `reactapp_APIURL + '/path'`, so '' makes them all relative and they resolve against
  // whatever origin served the page. nginx routes /graphql and the REST paths to the API
  // container and everything else to this one. That removes the CORS negotiation (app.ts
  // builds corsOptions from a single UI_URL), keeps server.js's `connect-src 'self'`
  // sufficient, and lets the secure/SameSite=Strict auth cookie work with no cross-site
  // rules. An absolute URL here would need all three handled separately, per tenant.
  if (domain.toLowerCase().endsWith('.dev.mhealthimpactlab.net')) return '';
  if (domain.toLowerCase() === 'echo-n4e21x-colorado.cfwebtools.com') return 'https://echo-api-n4e21x-colorado.cfwebtools.com';
  if (domain.toLowerCase() === 'echo-88sjg2-oregon.cfwebtools.com') return 'https://echo-api-88sjg2-oregon.cfwebtools.com';
  if (domain.toLowerCase() === 'echo-qgbsdp-virginia.cfwebtools.com') return 'https://echo-api-qgbsdp-virginia.cfwebtools.com';
  if (domain.toLowerCase() === 'echo-9sj23a-rutgers.cfwebtools.com') return 'https://echo-api-9sj23a-rutgers.cfwebtools.com';

  if (domain.toLowerCase() === 'echo-demo.cfwebtools.com') return 'https://echo-api-demo.cfwebtools.com';
  if (domain.toLowerCase() === 'echo-trial.cfwebtools.com') return 'https://echo-api-trial.cfwebtools.com';

  return 'https://echo-api-demo.cfwebtools.com';
}

function getAPITenantForProduction(): string {
  if (domain.toLowerCase() === 'connect.echocolorado.org') return 'https://api.echocolorado.org';
  if (domain.toLowerCase() === 'connect.oregonechonetwork.org') return 'https://api.oregonechonetwork.org';
  if (domain.toLowerCase() === 'connect.virginiaprojectecho.org') return 'https://api.virginiaprojectecho.org';

  if (domain.toLowerCase() === 'demo.echocolorado.org') return 'https://demo-api.echocolorado.org';

  return 'https://demo-api.echocolorado.org';
}

function getTenantForStaging(): string {
  // OIT data center -- one domain per tenant, same shape as production below. All four
  // are served by the SAME echo-ui and echo-api containers; the domain is the only thing
  // that distinguishes them, which is why dev needs more than one of them to be able to
  // test tenant routing at all.
  //
  // A missing line here fails QUIETLY: this function falls through to DEMO_TENANT_ID
  // rather than erroring, so a new domain loads normally and serves the wrong tenant's
  // data. Add the domain here at the same time as its DNS record and nginx vhost.
  if (domain.toLowerCase() === 'echo-co.dev.mhealthimpactlab.net') return COLORADO_TENANT_ID;
  if (domain.toLowerCase() === 'echo-oregon.dev.mhealthimpactlab.net') return OREGON_TENANT_ID;
  if (domain.toLowerCase() === 'echo-virginia.dev.mhealthimpactlab.net') return VIRGINIA_TENANT_ID;
  if (domain.toLowerCase() === 'echo-dartmouth.dev.mhealthimpactlab.net') return DARTMOUTH_TENANT_ID;
  if (domain.toLowerCase() === 'echo-n4e21x-colorado.cfwebtools.com') return COLORADO_TENANT_ID;
  if (domain.toLowerCase() === 'echo-88sjg2-oregon.cfwebtools.com') return OREGON_TENANT_ID;
  if (domain.toLowerCase() === 'echo-qgbsdp-virginia.cfwebtools.com') return VIRGINIA_TENANT_ID;
  if (domain.toLowerCase() === 'echo-9sj23a-rutgers.cfwebtools.com') return RUTGERS_TENANT_ID;
  
  if (domain.toLowerCase() === 'echo-demo.cfwebtools.com') return DEMO_TENANT_ID;
  if (domain.toLowerCase() === 'echo-trial.cfwebtools.com') return TRIAL_TENANT_ID;

  return DEMO_TENANT_ID;
}

function getTenantForProduction(): string {
  if (domain.toLowerCase() === 'connect.echocolorado.org') return COLORADO_TENANT_ID;
  if (domain.toLowerCase() === 'connect.oregonechonetwork.org') return OREGON_TENANT_ID;
  if (domain.toLowerCase() === 'connect.virginiaprojectecho.org') return VIRGINIA_TENANT_ID;
  if (domain.toLowerCase() === 'demo.echocolorado.org') return DEMO_TENANT_ID;
  
  return DEMO_TENANT_ID;
}

